module.exports = __webpack_public_path__ + "./images/yellow_thumb.23d8e3.jpg";